import http from "../http-common";

class UserDataService {
  getAll() {
    return http.get("/test/getusers");
  }

  getUserByDescr(condition, sortfield,sorttype) {
    return http.get(`/search/?username=${condition}&sortfield=${sortfield}&sorttype=${sorttype}`);
  }

  
  get(id) {
    return http.get(`/test/getusers/?id=${id}`);
  }

  update(id, data) {
    return http.put(`/auth/updateusersdata/?id=${id}`, data);
  }

}

export default new UserDataService();